export default __webpack_public_path__ + "static/media/hamburger_blue.5cf00038.svg";